import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Workout } from '@jungles/shared';
import { api } from '../lib/api';
import { useToast } from '../app/toast';
import { haptic } from '../lib/telegram';
import { Sheet } from './Sheet';

/**
 * «Новая тренировка · Как будем собирать?» — H5 и WorkoutSheet.
 * Шторка одна и та же на Главной и на экране Тренировок (SPEC §4).
 */
export function WorkoutPicker({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const alive = useRef(true), pending = useRef(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const dismiss = () => { if (!pending.current) onClose(); };

  const create = async (type: 'strength' | 'activity') => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    haptic();
    try {
      const workout = await api.post<Workout>('/api/workouts', { type });
      if (alive.current) navigate(`/workouts/${workout.id}`);
    } catch (error) {
      if (!alive.current) return;
      pending.current = false;
      toast(error instanceof Error ? error.message : 'Не удалось создать тренировку');
      setBusy(false);
    }
  };

  return (
    <Sheet title="Новая тренировка" onClose={dismiss} busy={busy}>
      <p className="nt" style={{ margin: '4px 0 4px' }}>
        Как будем собирать?
      </p>

      <button className="opt pr" disabled={busy} type="button" onClick={() => void create('strength')}>
        <b>Собрать самому</b>
        <span>Упражнения по одному, подходы и вес</span>
        <img src="/assets/ui/tab-workouts.webp" alt="" />
      </button>

      <button
        className="opt"
        disabled={busy}
        type="button"
        onClick={() => {
          haptic();
          navigate('/workouts/templates');
        }}
      >
        <b>Из готовых</b>
        <span>Программа уже расписана, впишите вес</span>
        <img src="/assets/ui/tab-arena.webp" alt="" />
      </button>

      <button className="opt" disabled={busy} type="button" onClick={() => void create('activity')}>
        <b>Кардио</b>
        <span>Бег, прогулка и другое — время и дистанция</span>
        <img src="/assets/ui/activity-cardio.webp" alt="" />
      </button>

      <button className="b ghost" type="button" disabled={busy} onClick={dismiss} style={{ marginTop: 8 }}>
        Отмена
      </button>
    </Sheet>
  );
}
